import controller from './footer-core.controller';
import templateBase from './templates/footer-core-base.view.html';
import templateT1 from './templates/footer-core-t1.view.html';
import templateT2 from './templates/footer-core-T2.view.html';
import templateT3 from './templates/footer-core-t3.view.html';
import templateT4 from './templates/footer-core-t4.view.html';
import templateT5 from './templates/footer-core-t5.view.html';
import templateT6 from './templates/footer-core-t6.view.html';
import templateT7 from './templates/footer-core-t7.view.html';
import templateT8 from './templates/footer-core-t8.view.html';
import templateT9 from './templates/footer-core-t9.view.html';
import templateT10 from './templates/footer-core-t10.view.html';
import templateT11 from './templates/footer-core-t11.view.html';
import templateT12 from './templates/footer-core-t12.view.html';
import templateT13 from './templates/footer-core-t13.view.html';
import templateT15 from './templates/footer-core-t15.view.html';
import templateAD from './templates/footer-adaptative.html';

let FooterCoreComponent = {
  template: changeTemplate,
  controller,
  bindings: {
    shCtrl: '<'
  }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
    let response = SessionService.get('components');
  if(__env.adaptative){
    return templateAD;
  } else {
    if(response.FOOTER.component == 'template_t1'){ return templateT1 }
    else if(response.FOOTER.component == 'template_t2'){ return templateT2 }
    else if (response.FOOTER.component == 'template_t3') { return templateT3 }
    else if (response.FOOTER.component == 'template_t4') { return templateT4 }
    else if (response.FOOTER.component == 'template_t5') { return templateT5 }
    else if (response.FOOTER.component == 'template_t6') { return templateT6 }
    else if (response.FOOTER.component == 'template_t7') { return templateT7 }
    else if (response.FOOTER.component == 'template_t8') { return templateT8 }
    else if (response.FOOTER.component == 'template_t9') { return templateT9 }
    else if (response.FOOTER.component == 'template_t10') { return templateT10 }
    else if (response.FOOTER.component == 'template_t11') { return templateT11 }
    else if (response.FOOTER.component == 'template_t12') { return templateT12 }
    else if (response.FOOTER.component == 'template_t13') { return templateT13 }
    else if (response.FOOTER.component == 'template_t15') { return templateT15 }
    else{ return templateBase; }
  }
}

export default FooterCoreComponent;


// WEBPACK FOOTER //
// ./www/components/footer-core/footer-core.component.js